import request from './base';
import {excludeObjNullValue} from 'utils/common';

/**
 * award endpoints
 */
export const fetchAwards = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/awards', q, page, perPage, sortOpts, extraParams);

export const fetchAllAwards = (level) =>
  request.fetchList('/awards', undefined, 1, 100, {sortField: 'points', sortDir: 'asc'}, {level});

export const fetchAward = (awardId) => request.fetchDetail(`/awards/${awardId}`);

export const createAward = (payload) => {
  const formData = new FormData();
  const data = excludeObjNullValue({
    title: payload.title,
    points: payload.points,
    level: payload.level,
    image: payload.image,
    game: payload.game,
  });
  for (const [k, v] of Object.entries(data)) {
    formData.append(k, v);
  }
  return request.postForm('/awards', formData);
};

export const updateAward = (payload) => {
  const formData = new FormData();
  const data = excludeObjNullValue({
    title: payload.title,
    points: payload.points,
    level: payload.level,
    image: payload.image,
    game: payload.game,
  });
  for (const [k, v] of Object.entries(data)) {
    formData.append(k, v);
  }
  return request.putForm(`/awards/${payload.awardId}`, formData);
};

export const deleteAward = (awardId) => request.deleteReq(`/awards/${awardId}`);
